/**
 * DOM id for the marketing-banner portal outlet rendered by `PageHeader`.
 * Must stay in sync with `getPortalId(Portal.PAGE_MARKETING_BANNER)` in
 * `libs/+split-me/src/core/portals` (`portal-slot-page_marketing_banner`).
 */
export const pageMarketingBannerPortalId = 'portal-slot-page_marketing_banner';
